exports = module.exports = require("../node_modules/.0.25.0@css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".box[data-v-2a1ff92f]{display:flex;min-height:100vh;flex-direction:column;background-image:url(" + require("./assets/底纹.jpg") + ");font-family:微软雅黑}main[data-v-2a1ff92f]{flex-grow:1}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/.0.25.0@css-loader?minimize!./~/.11.3.4@vue-loader/lib/style-compiler?{"id":"data-v-2a1ff92f","scoped":true,"hasInlineConfig":false}!./~/.11.3.4@vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 197
// module chunks = 2